module.exports = __webpack_public_path__ + "img/progress_016.72230482.png";